import { STATIC_ASSETS_PLACEHOLDER } from "../staticAssetsPlaceholder.js";
const bezierConfig = { p0: 0.68, p1: -0.2, p2: 0.32, p3: 1.2 };
const colors = ["#05819088", "#D0382088", "#D1587A88", "#45658D88"];
export const paintDaubs = {
    version: 1,
    themeId: "paint-daubs",
    name: "Paint Daubs",
    endFadeDuration: 1,
    thumbnailFrame: 100,
    thumbnailUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/theme-stills/paint-daubs.webp`,
    background: [
        {
            variant: "scattered",
            adjustTimeSeconds: 1.5,
            count: 150,
            urls: [
                {
                    full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/paint-daub-1.webp`,
                    preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/optimized/paint-daub-1.webp`,
                },
                {
                    full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/paint-daub-2.png`,
                    preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/optimized/paint-daub-2.png`,
                },
                {
                    full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/paint-daub-3.webp`,
                    preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/optimized/paint-daub-3.webp`,
                },
                {
                    full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/paint-daub-4.png`,
                    preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/optimized/paint-daub-4.png`,
                },
                {
                    full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/paint-daub-5.png`,
                    preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/optimized/paint-daub-5.png`,
                },
            ],
        },
    ],
    scenes: [
        {
            type: "paintDaubsIntro",
            durationSeconds: 5,
            mask1: {
                full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/intro-mask-1.webp`,
                preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/optimized/intro-mask-1.webp`,
            },
            mask2: {
                full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/intro-mask-2.1.webp`,
                preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/optimized/intro-mask-2.1.webp`,
            },
            faceCollage: {
                variant: "top-bottom-static",
                borderShape: "circle",
                entrance: {
                    variant: "stagger-in",
                    transitionDurationInFrames: 15,
                    topStyle: {
                        rotate: `-12deg`,
                        translate: `4rem 3rem`,
                        width: "85%",
                    },
                    bottomStyle: {
                        rotate: `8deg`,
                        width: "85%",
                        translate: `-4rem 0rem`,
                    },
                },
            },
        },
        {
            type: "greetingLinesAsScenes",
            variant: "intro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            sceneBackground: {
                variant: "coloredMask",
                colors,
                maskUrl: {
                    full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/mask3.webp`,
                    preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/optimized/mask3.webp`,
                },
            },
        },
        {
            type: "clip-series-basic",
            showLogo: true,
            sceneBackground: {
                variant: "coloredMask",
                colors,
                maskUrl: {
                    full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/mask3.webp`,
                    preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/optimized/mask3.webp`,
                },
            },
        },
        {
            type: "greetingLinesAsScenes",
            variant: "outro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            sceneBackground: {
                variant: "coloredMask",
                colors,
                maskUrl: {
                    full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/mask3.webp`,
                    preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/optimized/mask3.webp`,
                },
            },
        },
        {
            type: "outro",
            colorVariant: "lightBlue",
            sceneBackground: {
                variant: "coloredMask",
                colors,
                maskUrl: {
                    full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/mask3.webp`,
                    preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/optimized/mask3.webp`,
                },
            },
        },
    ],
    styles: {
        textBox: {
            backgroundColor: "#fff",
            backgroundOpacity: 0,
            backgroundBlur: 2,
            textAlign: "center",
            textColor: "white",
            fontFamily: "Londrina Solid",
            fontWeight: "light",
            fontSize: 96,
            leading: 1.1,
            tracking: 0,
            custom: {
                textShadow: "0.5rem 0.5rem 0.5rem rgba(0,0,0,0.1)",
            },
        },
        clips: {
            textVariant: {
                variant: "slide-in-static",
                entranceVariant: "slide-to-flush-left",
                transitionDurationSeconds: 0.75,
                startOffsetSeconds: 0.6,
                cards: [
                    {
                        backgroundColor: "#1e1e24",
                        backgroundOpacity: 0,
                        borderRadius: "1.5rem",
                        paddingTop: "4rem",
                        paddingBottom: "4rem",
                        paddingRight: "8rem",
                        backgroundImages: [
                            {
                                url: {
                                    full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/caption.png`,
                                    preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/paint-daubs/optimized/caption.png`,
                                },
                                style: {
                                    opacity: 1,
                                    backgroundSize: "100% 100%",
                                    backgroundPosition: "center",
                                    backgroundRepeat: "no-repeat",
                                },
                            },
                        ],
                    },
                ],
            },
            betweenTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: {
                    variant: "bezier",
                    config: bezierConfig,
                    durationSeconds: 1.25,
                },
            },
            title: {
                backgroundColor: "#fff",
                backgroundOpacity: 0.95,
                textColor: "white",
                fontFamily: "Londrina Solid",
                fontWeight: "black",
                fontSize: 60,
                nudge: 2,
                textTransform: "none",
            },
            subtitle: {
                backgroundColor: "#3f3f46",
                backgroundOpacity: 0.95,
                textColor: "white",
                fontFamily: "Londrina Solid",
                fontWeight: "light",
                fontSize: 40,
                nudge: 2,
                textTransform: "none",
            },
            scaleFactor: 1,
        },
        watermark: {
            opacity: 0.8,
            margin: 32,
            enterTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
            exitTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
        },
        sceneTransition: {
            variant: "marginSlide",
            direction: "from-left",
            timing: {
                variant: "linear",
                easing: "easeInOut",
                durationSeconds: 1,
            },
        },
    },
    userInputFields: [
        {
            id: "title1",
            type: "text",
            label: "Title 1",
            defaultValue: "",
            placeholder: "Congrats!",
            required: true,
            min: 1,
            max: 15,
            preview: {
                sceneIndex: 0,
                frameOffset: 90,
            },
        },
        {
            id: "title2",
            type: "text",
            label: "Title 2",
            defaultValue: "",
            placeholder: "So Exciting!",
            required: true,
            min: 1,
            max: 15,
            preview: {
                sceneIndex: 0,
                frameOffset: 90,
            },
        },
    ],
};
